import { useState } from "react";
import { PDFDocument } from "pdf-lib";

const PdfCompressor = () => {
  const [pdfFile, setPdfFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [compressedUrl, setCompressedUrl] = useState(null);
  const [originalSize, setOriginalSize] = useState(null);
  const [compressedSize, setCompressedSize] = useState(null);
  const [compressionLevel, setCompressionLevel] = useState("medium");

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type === "application/pdf") {
      setPdfFile(file);
      setFileName(file.name);
      setOriginalSize((file.size / 1024).toFixed(2));
      compressPdf(file);
    }
  };

  const compressPdf = async (file) => {
    const arrayBuffer = await file.arrayBuffer();
    const pdfDoc = await PDFDocument.load(arrayBuffer);

    // Compress PDF (this reduces size by removing metadata and compressing images if possible)
    const compressedPdfBytes = await pdfDoc.save({ useObjectStreams: true });

    const blob = new Blob([compressedPdfBytes], { type: "application/pdf" });
    setCompressedSize((blob.size / 1024).toFixed(2));
    setCompressedUrl(URL.createObjectURL(blob));
  };

  const handleReset = () => {
    setPdfFile(null);
    setFileName("");
    setCompressedUrl(null);
    setOriginalSize(null);
    setCompressedSize(null);
    document.getElementById("pdfFileInput").value = "";
  };

  return (
    <div className="">
      <h2 className="mb-4">PDF Compressor Tool</h2>
      <input
        type="file"
        id="pdfFileInput"
        accept=".pdf"
        className="form-control mb-3"
        onChange={handleFileChange}
      />

      {pdfFile && (
        <>
          <div className="mb-3">
            <strong>File:</strong> {fileName} <br />
            <strong>Original Size:</strong> {originalSize} KB <br />
            <strong>Compressed Size:</strong> {compressedSize} KB
          </div>

          <div className="mb-3">
            <button className="btn btn-success me-2 bigsize" disabled={!compressedUrl}>
              <a
                href={compressedUrl}
                download={`compressed-${fileName}`}
                className="text-white text-decoration-none"
              >
                Download Compressed PDF
              </a>
            </button>
            <button className="btn btn-danger bigsize" onClick={handleReset}>
              Remove File
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default PdfCompressor;
